import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate } from '../../public/utility'
import { doGetForgetSwipeCardApply, doSaveForgetSwipeCardApply, doDeleteForgetSwipeCardApply } from '../../reducers/actions'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import { doForgetSwipeCardApplyAction } from '../../business/ForgetSwipeCardApplyAction'
class ForgetSwipeCardApplyDetail extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    componentDidMount = () => {
        this.doGetForgetSwipeCardApply(this.props.id, this.props.checkRecordID, '', true)
    }

    doGetForgetSwipeCardApply = (id, checkRecordID, date, bChanged) => {
        const { dispatch, taskName } = this.props
        const { changedValues基本信息 } = this.state
        dispatch(doGetForgetSwipeCardApply({
            id: id || 0,
            checkRecordID,
            date,
            taskName,
            onEnd: ({ errorMessage, initValues基本信息, }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    if (bChanged) {
                        this.setState({ id, initValues基本信息, changedValues基本信息: {}, })
                    }
                    else {
                        const newChange = {
                            ...changedValues基本信息,
                            上班刷卡时间: initValues基本信息.上班刷卡时间, 下班刷卡时间: initValues基本信息.下班刷卡时间,
                            实际上班时间: initValues基本信息.实际上班时间, 实际下班时间: initValues基本信息.实际下班时间
                        }
                        this.setState({ id, initValues基本信息, changedValues基本信息: newChange })
                    }
                }
            }
        }))
    }

    handlerSave = () => {
        const { dispatch, onSave, onClose, checkRecordID } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        dispatch(doSaveForgetSwipeCardApply({
            id,
            checkRecordID,
            changedValues基本信息,
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    this.setState({ id })
                    this.doGetForgetSwipeCardApply(id, 0, '', true)
                }
            }
        }))
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0 &&
            values.忘刷卡日期 && values.实际上班时间 && values.实际上班时间 !== nullDate && values.实际下班时间 && values.实际下班时间 !== nullDate &&
            values.原因说明 && (values['附件-added'] || (values.附件 && values.附件.length > 0))
    }

    bSubmit = () => {
        const { initValues基本信息, changedValues基本信息, id } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0
    }

    handelSubmit = (action, title) => {
        const { onSave, onClose, dispatch, showDetail } = this.props
        const { id } = this.state
        doForgetSwipeCardApplyAction(dispatch, title, { id: id, action: action, onSave: this.handlerClose, showDetail: showDetail })
    }

    handleChange = (v) => {
        this.doGetForgetSwipeCardApply(this.props.id, this.props.checkRecordID, v, false)
    }

    handlerDelete = () => {
        const { dispatch, onClose, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            dispatch(doDeleteForgetSwipeCardApply({
                id,
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            })))
    }

    fieldset基本信息 = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return [
            { _text: '申请编号', minWidth: '45%', disabled: true, },
            { _date: '创建日期', minWidth: '45%', disabled: true, },
            { _text: '员工编号', minWidth: '45%', disabled: true, },
            { _text: '员工姓名', minWidth: '45%', disabled: true, },
            { _text: '部门名称', minWidth: '45%', disabled: true, },
            { _text: '职务名称', minWidth: '45%', disabled: true, },
            { _select: '忘刷卡日期', minWidth: '90%', options: values.items忘刷卡日期, onChange: (v) => this.handleChange(v), required: true, },
            { _datetime: '上班刷卡时间', minWidth: '45%', disabled: true, },
            { _datetime: '下班刷卡时间', minWidth: '45%', disabled: true, },
            { _datetime: '上班忘刷卡时间', name: '实际上班时间', minWidth: '45%', required: true, },
            { _datetime: '下班忘刷卡时间', name: '实际下班时间', minWidth: '45%', required: true, },
            { _text: '原因说明', minWidth: '90%', required: true, },
            { _files: '附件', minWidth: '90%', required: true, },
            { _text: '备注', minWidth: '90%', maxRows: 3, },
        ]
    }

    fieldset流转日志 = () => {
        return [
            { _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
    }

    fieldset签核流程 = () => {
        return [
            { _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
    }


    render() {
        const { showMessage: Message, showBody: Body, readOnly, notSubmit } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态, 提交时间 } = initValues基本信息
        const bSubmit = this.bSubmit()
        return <Body data={this} maxWidth="1100"
            controls={
                readOnly ? [
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose }
                ] : [
                    { _flow: 'ForgetSwipeCardApplyFlow', disabled: this.bSave(), cdt: () => id > 0 && (!notSubmit || 状态 == 1), id: getFormValue(this, '基本信息', 'ArchivesID') },
                    // { _button: '退回申请', icon: 'reply', ui: 'action decline alt', handler: () => this.handelSubmit(`${状态名称}.退回申请`, '退回申请'), cdt: () => id > 0 && 状态 > 1 && !notSubmit, disabled: bSubmit },
                    // { _button: 状态名称 != '申请中' ? '确认' : '提交', icon: 'share', handler: () => this.handelSubmit(`${状态名称}.提交`, '提交'), cdt: () => id > 0 && (状态 == 1 || (状态 == 2 && !notSubmit)) && 状态名称 !== '批准中', disabled: bSubmit },
                    // { _button: '批准', icon: 'share', handler: () => this.handelSubmit(`${状态名称}.批准`, '批准'), cdt: () => id > 0 && 状态名称 == '批准中' && !notSubmit, disabled: bSubmit },
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), cdt: () => 状态 == 1, },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 && 状态 == 1 && 提交时间 == nullDate },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '忘刷卡申请单', name: '基本信息', _fieldset: this.fieldset基本信息(), docked: 'top', height: '68%', disabled: 状态 !== 1 || readOnly },
                    {
                        _fieldsets: [
                            { title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
                            { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
                        ]
                    }
                ]
            }
        />
    }
}

export default connect()(ForgetSwipeCardApplyDetail)